// ============================================================
// TERROR ENGINE — CDN
// One file. One domain. One truth.
// Every image in every zone pulls from here.
// To move assets to a new domain: change one line.
// ============================================================

export const CDN = "https://terror-assets.pages.dev";

// ── Asset URL helpers ─────────────────────────────────────────
export const cdnUrl  = (filename) => `${CDN}/${filename}`;
export const cardUrl = (cardId)   => `${CDN}/${cardId}.webp`;
